/* mc-nav.js — the navigation drawer.

   The drawer itself is <details>/<summary> and CSS: it opens, it slides,
   it closes from the X, and it does all of that with this file blocked.
   That is deliberate — navigation is the one thing on a page that must
   never depend on a script loading.

   What is added here is only what markup cannot do:
     · tap the scrim to close
     · Escape to close
     · the page behind stops scrolling while it is open
     · focus moves into the drawer, and back to the button after

   Nothing here is required for the menu to work. */
(function () {
  'use strict';

  var root = document.querySelector('[data-mc-nav]');
  if (!root) return;

  var summary = root.querySelector('summary');
  var panel   = root.querySelector('.mc-head__drawer');
  var scrollY = 0;

  function close() {
    if (!root.open) return;
    root.open = false;
  }

  function lock() {
    /* position:fixed rather than overflow:hidden — iOS Safari ignores
       overflow on <body> and scrolls the page behind the drawer anyway,
       which drags the drawer's own content out of view. */
    scrollY = window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollY + 'px';
    document.body.style.width = '100%';
  }

  function unlock() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  root.addEventListener('toggle', function () {
    /* The drawer is a phone control. Above 990px the same <details> is a
       small dropdown next to the logo, and locking the page for a
       dropdown would be absurd. */
    var isDrawer = window.matchMedia('(max-width: 989px)').matches;

    if (root.open) {
      if (isDrawer) lock();
      var first = panel && panel.querySelector('a');
      if (first && isDrawer) first.focus({ preventScroll: true });
    } else {
      if (document.body.style.position === 'fixed') unlock();
      if (summary && document.activeElement === document.body) summary.focus();
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mc-nav-close]')) { close(); return; }
    /* A link inside the drawer navigates; on a same-page anchor there is
       no navigation, so the drawer would stay open over the target. */
    if (e.target.closest('.mc-head__drawer a')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  /* Rotating to landscape can cross the 990px line with the drawer open,
     leaving the page locked behind a dropdown. */
  window.addEventListener('resize', function () {
    if (root.open && !window.matchMedia('(max-width: 989px)').matches) close();
  }, { passive: true });
})();

/* ── Desktop dropdowns and mega panels ───────────────────────

   The block above is the phone's drawer. These are the header's own
   <details> menus, and nothing has ever closed them: opening „Pokloni"
   and then clicking into the page left the panel standing over the
   content, and opening „Nakit" next left both open at once — which with
   a full-width mega panel means one panel drawn on top of another.

   Same contract as the drawer. Markup opens and closes them from their
   own summary; this only tidies up after. With the file blocked every
   menu still works, it just stays open until you click it again. */
(function () {
  'use strict';

  function closeAll(except) {
    var all = document.querySelectorAll('[data-mc-drop][open]');
    for (var i = 0; i < all.length; i++) {
      if (all[i] !== except) all[i].open = false;
    }
  }

  /* Capture, because `toggle` does not bubble. */
  document.addEventListener(
    'toggle',
    function (e) {
      var d = e.target;
      if (d && d.hasAttribute && d.hasAttribute('data-mc-drop') && d.open) closeAll(d);
    },
    true
  );

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    /* A click inside a panel is either a link, which navigates, or dead
       space — neither is a reason to close the menu under the cursor. */
    if (e.target.closest('[data-mc-drop]')) return;
    closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-mc-drop][open]');
    if (!open) return;
    var s = open.querySelector('summary');
    open.open = false;
    if (s) s.focus();
  });
})();
